import axios from 'api/axios';
import { getTokensPath } from '../Tokens/apiPaths';
import { getJumpCloudSsoCallbackPath, getPasswordPath, getResetPasswordPath } from './apiPaths';
export var getForgetPasswordPostRequest = function getForgetPasswordPostRequest(props) {
    return axios.post(getResetPasswordPath(), props);
};
export var getResetPasswordPostRequest = function getResetPasswordPostRequest(props) {
    return axios.post(getPasswordPath(), props);
};
export var getLoginPostRequest = function getLoginPostRequest(props) {
    return axios.post(getTokensPath(), props);
};
export var getJumpCloudSsoCallbackRequest = function getJumpCloudSsoCallbackRequest(params, tenant) {
    return axios.get(getJumpCloudSsoCallbackPath(tenant), {
        params: params
    });
};
